<template>
	<div class="SocialmediaCronBrandsList">
		<v-layout row class="">


			<v-flex xs12 sm6 offset-sm3>
				<v-card>
					<template v-if="isLoading">
						<div class="text-xs-center pa-5">
							<v-progress-circular :size="50" color="teal" indeterminate></v-progress-circular>
							<div class="caption mt-4">Müşteri listesi yükleniyor</div>
						</div>
					</template>
					<template v-if="!isLoading">
						<v-toolbar color="indigo" dark>
							<v-text-field flat solo-inverted hide-details prepend-inner-icon="search" v-model="searchBrand" label="Müşteri Ara">
							</v-text-field>
							<v-btn icon @click="openEdit(false)">
								<v-icon>add_circle</v-icon>
							</v-btn>
						</v-toolbar>

						<v-list >
							<template v-for="(brand, brandIndex) in getBrands"> 
								<v-list-tile :key="brandIndex" avatar @click="openEdit(brand)">
									<v-list-tile-avatar>
										<img :src="brand.logo">
									</v-list-tile-avatar>

									<v-list-tile-content>
										<v-list-tile-title v-html="brand.brand_name"></v-list-tile-title> 
									</v-list-tile-content>
								</v-list-tile>
							</template>
						</v-list>
					</template>
				</v-card>
			</v-flex>


			<v-dialog v-model="dialogNewAccount" max-width="600px">
				<v-card class="SocialmediaCronBrandsListEditor">
					<v-card-title>
						<span class="headline" v-if="editBrand.id == ''">Yeni Bir Marka Ekle</span>
						<span class="headline" v-if="editBrand.id != ''">Markayı Düzenle</span>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap>
								<v-flex xs12>
									<v-text-field v-model="editBrand.brand_name" label="Marka Adı" hint="marka adı"
										persistent-hint outline required></v-text-field>
								</v-flex>
								<v-flex xs12>
									<v-combobox v-model="editBrand.tags" outline hide-selected label="Tag ekle" multiple
										persistent-hint small-chips>
										<template slot="no-data">
											<v-list-tile>
												<v-list-tile-content>
													<v-list-tile-title>
														Eklemek için <kbd>enter</kbd> a basın
													</v-list-tile-title>
												</v-list-tile-content>
											</v-list-tile>
										</template>
									</v-combobox>
								</v-flex>

								<v-flex xs12>
									<div class="IGAccount">
										<div class="IGAccountTitle">Instagram Hesabı</div>
										<div class="IGAccountBody">
											<div class="IGAccountInfo">
												<div class="IGAccountInfoLogo">
													<img :src="editBrand.instagram_profile" alt="">
												</div>
												<div class="IGAccountInfoName">
													{{editBrand.instagram_fullname}}
												</div>
											</div>
											<div class="IGAccountForm">
												<div class="IGAccountFormInput">
													<input type="text" v-model="editBrand.instagram_username">
												</div>
												<div class="IGAccountFormInput">
													<input type="text" v-model="editBrand.instagram_password">
												</div>
												<div class="IGAccountFormButton">
													<v-btn small depressed  :color="instagramConnectFailed ? 'error' : 'tail'" 
														:loading="instagramConnecting" 
														@click="doConnectInstagram()"
													>Giriş</v-btn>
												</div>
											</div>
										</div>
									</div>
								</v-flex>
								<v-flex xs12>
									<div class="IGLocation">
										<div class="IGLocationTitle">Instagram Lokasyon</div>
										<div class="IGLocationBody"> 
											<div class="IGLocationInfo">
												<div class="IGLocationText">
													<div class="IGLocationName">{{editBrand.instagram_location_name}}</div>
													<div class="IGLocationAddress">{{editBrand.instagram_location_address}}</div>
												</div>
												<div class="IGLocationSpace"> </div>  
												<div class="IGLocationButton">
													<v-btn small depressed  color="secondary" @click="openChangeLocation()">DEĞİŞTİR</v-btn>
												</div>
											</div>
										</div>
									</div>
								</v-flex>

							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions class="pr-4 pl-4 pb-4">
						<v-btn round outline color="error" dark @click="closeEdit()">Vazgeç</v-btn>
						<v-spacer></v-spacer>
						<v-btn round color="primary" :loading="brandSaving" dark @click="saveBrand()">Kaydet</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>

			<v-snackbar v-model="instagramConnectFailedAlertShow" :timeout="instagramConnectFailedAlertTimeout" top color="error" > 
				{{ instagramConnectFailedAlertText }} 
				<v-btn color="white" flat @click="instagramConnectFailedAlertShow = false" > Tamam </v-btn> 
			</v-snackbar>

			<v-dialog v-model="dialogNewAccountIGLocation" persistent  max-width="400px">
				<v-card class="SocialmediaCronBrandsListEditor">
					<v-card-title>
						<span class="headline">Lokasyonu değiştir</span>
					</v-card-title>
					<v-card-text>
						<v-container grid-list-md>
							<v-layout wrap v-show="instagramLocation.isLoading"> 
								<v-flex xs12>
									<div class="text-xs-center pa-5">
										<v-progress-circular :size="50" color="teal" indeterminate></v-progress-circular>
										<div class="caption mt-4">Sonuçlar getiriliyor</div>
									</div>
								</v-flex> 
							</v-layout>
							<v-layout wrap v-show="!instagramLocation.isLoading">
								<v-flex xs12>
									<v-text-field v-model="instagramLocation.search" label="Aranacak kelime" outline hide-details></v-text-field>
								</v-flex> 
								<v-flex xs12>
									<div class="text-xs-center">
										<v-btn round color="teal" dark @click="doSearchLocations()">Sonuçları Getir</v-btn>
									</div>
								</v-flex> 
								<v-flex xs12>
									<v-select
										v-model="instagramLocation.item"
										:items="instagramLocation.items"
										item-text="name"
										item-value="index"
										label="Konumu seçin"
										outline hide-details
									></v-select>
								</v-flex>  
							</v-layout>
						</v-container>
					</v-card-text>
					<v-card-actions class="pr-4 pl-4 pb-4">
						<v-btn round outline color="error" dark @click="closeChangeLocation()">Vazgeç</v-btn>
						<v-spacer></v-spacer>
						<v-btn round color="success" dark @click="setChangeLocationItem()">Seç</v-btn>
					</v-card-actions>
				</v-card>
			</v-dialog>







		</v-layout>
	</div>
</template>


<script>
	export default {
		name: "SocialmediaCronBrandsList",
		data: () => ({
			dialogNewAccount: false,
			isLoading : true,
			searchBrand : "",
			brands : [],
			editBrand: {},
			brandSaving : false,
			dialogNewAccountIGLocation: false, 
			instagramConnecting : false,
			instagramConnectFailed : false,
			instagramConnectFailedAlertShow : false,
			instagramConnectFailedAlertText : "",
			instagramConnectFailedAlertTimeout : 6000,
			instagramLocation : {
				search : "",
				isLoading : false,
				items : [{ index : 0, external_id : "", name : "Herhangi bir yer tanımlı değil", address : "" }],
				item : 0
			}
		}),
		mounted() {
			this.loadBrands()
			this.setNewAccountData()
		},
		methods: {
			loadBrands(){
				this.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/socialmedia/cron/brands/", {
					params : { }
				}).then(response => {  
					this.brands = response.body;
					this.isLoading = false; 
				}) 
			},
			setNewAccountData() {
				this.editBrand = {
					id : "",
					brand_name: "",
					description: "",
					tags: [],
					logo: "",
					instagram_username: "",
					instagram_password: "",
					instagram_fullname: "",
					instagram_profile: "",
					instagram_location_id: "",
					instagram_location_name: "",
					instagram_location_address: "",
				}
			},
			closeEdit(){
				this.dialogNewAccount = false;
			},
			openEdit(item){
				if(item){
					this.editBrand = item
				}else{
					this.setNewAccountData();
				}
				this.dialogNewAccount = true;
			},
			saveBrand(){
				this.brandSaving = true;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cron/brands/save", this.editBrand, {
					params: { }
				}).then(response => { 
					this.brandSaving = false; 
					this.closeEdit()
					this.loadBrands()
				})
			},
			doConnectInstagram(){
				if(this.instagramConnecting){
					return false
				}
				this.instagramConnecting = true;
				this.instagramConnectFailed = false;
				this.$http.post(process.env.VUE_APP_API_URL + "/socialmedia/cron/brands/instagram_connect", {
					username : this.editBrand.instagram_username,
					password : this.editBrand.instagram_password,
				}, {
					params: { }
				}).then(response => { 
					this.instagramConnecting = false;
					if(response.body.success){
						this.editBrand.instagram_fullname = response.body.fullname
						this.editBrand.instagram_profile = response.body.profile
						this.editBrand.logo = response.body.profile
					}else{ 
						this.instagramConnectFailed = true;
						this.instagramConnectFailedAlertShow = true;
						this.instagramConnectFailedAlertText = response.body.text;
					}
				})
			},

			openChangeLocation(){
				this.dialogNewAccount = false;
				this.dialogNewAccountIGLocation = true;
				this.instagramLocation.isLoading = false; 
			},
			closeChangeLocation(){
				this.dialogNewAccount = true;
				this.dialogNewAccountIGLocation = false;
			},
			doSearchLocations(){
				this.instagramLocation.isLoading = true; 
				this.$http.get( process.env.VUE_APP_API_URL + "/socialmedia/cron/brands/instagram_locations/", {
					params : {
						search : this.instagramLocation.search
					}
				}).then(response => {   
					this.instagramLocation.items = [{ index : 0, external_id : "", name : "Herhangi bir yer tanımlı değil", address : "" }];
					this.instagramLocation.item = 0;
					for(var i in response.body){
						response.body[i].index = this.instagramLocation.items.length;
						this.instagramLocation.items.push(response.body[i])
					} 
					this.instagramLocation.isLoading = false; 
				}) 
			},
			setChangeLocationItem(){
				var location = this.instagramLocation.items[ this.instagramLocation.item ] 
				this.editBrand.instagram_location_id = location.external_id;
				this.editBrand.instagram_location_name = location.name;
				this.editBrand.instagram_location_address = location.address;
				this.closeChangeLocation()
			}
		},
		computed : {
			getBrands(){
				var brands = [];
				var searchBrand = this.searchBrand.toLowerCase(); 
				brands = this.brands.filter( function(item) { 
					if( searchBrand != ""){
						if( item.brand_name.toLowerCase().indexOf(searchBrand) < 0 ){ return false; }
					}
					return true;
				})   
				return brands;
			}
		}
	}
</script>


<style lang="less">
	.SocialmediaCronBrandsList {
		padding-top: 20px;
		@media(max-width : 500px){
			padding : 5px;
		}

	}

	.SocialmediaCronBrandsListEditor {

		.IGAccount{
			border:2px solid #aaa; 
			border-radius: 4px;
			margin-bottom : 15px;
			.IGAccountTitle{
				margin-left:10px;
				margin-top:-10px;
				display: table;
				background-color: #fff;
				padding:0px 10px;
			}
			.IGAccountBody{
				padding : 4px 10px 10px 10px;
				.IGAccountInfo{
					width : 100%;
					height : 36px;
					.IGAccountInfoLogo{
						width : 32px;
						height : 32px;
						border-radius: 50%;
						background-color: #ddd;
						float:left;
						img{
							width : 100%;
							height : 100%;
							border-radius: 50%;
							object-fit: cover;
						}
					}
					.IGAccountInfoName{
						float: left;
						width : calc(~"100% - 32px");
						line-height : 32px;
						padding-left : 10px;
					}
				}
				.IGAccountForm{
					display: flex;
					.IGAccountFormInput{
						flex : 1;
						input{
							border:1px solid #aaa;
							width : calc(~"100% - 10px");
							line-height: 26px;
							border-radius: 3px;
							padding : 0px 6px;
							font-size : 12px;
						}
					}
					.IGAccountFormButton{
						button{
							margin: 0px;
						}
					}
				}
			}
		}

		.IGLocation{
			border:2px solid #aaa; 
			border-radius: 4px;
			.IGLocationTitle{
				margin-left:10px;
				margin-top:-10px;
				display: table;
				background-color: #fff;
				padding:0px 10px;
			}
			.IGLocationBody{
				padding : 4px 10px 10px 10px;
				.IGLocationInfo{
					display: flex;
					width: 100%;
					.IGLocationText{
						width : calc(~"100% - 100px");
						.IGLocationName{
							font-size : 13px;
							font-weight: 700;
						}
						.IGLocationAddress{ 
							font-size : 13px;
							white-space: nowrap;
							overflow: hidden;
							text-overflow: ellipsis;
						}
					}
					.IGLocationSpace{
						flex :  1;
					}
					.IGLocationButton{
						text-align: right;
						button{
							margin: 0px;
							margin-top:7px;
						}
					}
				}
			}
		}

		.account-list {
			.account {
				display: flex;

				&:not(:last-child) {
					margin-bottom: 15px;
					padding-bottom: 15px;
					border-bottom: 2px dashed #ccc;
				}

				.form-control {
					border: 1px solid #ccc;
					padding: 0px 10px;
					line-height: 30px;
					margin-top: 4px;
					width: 100%;
					min-width: 0px;
					border-radius: 30px;
					box-sizing: border-box;
					height: 30px;
				}

				.logo {
					width: 40px;
					height: 40px;
					border-radius: 50%;
					overflow: hidden;
					background: #ccc;
					margin-right: 5px;

					img {
						width: 100%;
						height: 100%;
						object-fit: cover;
					}
				}

				.name {
					flex: 1;
					line-height: 40px;
					font-weight: 700;

					.v-input {
						margin-top: 0px;
						padding-top: 0px;
					}
				}

				.username {
					width: 120px;
					margin-right: 5px;
					input{
						outline: none;
					}
				}

				.password {
					width: 120px;
					margin-right: 5px;
					input{
						outline: none;
					}
				}

				.status {
					line-height: 40px;
				}
			}
		}

	}
</style>